import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { Notification } from '@core-argos-angular-artifact/components';
import { NotificationService } from './notification.service';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';

@Injectable()
export class ErrorHandlerService implements ErrorHandler {
  constructor(private readonly injector: Injector) {}

  handleError(error: Error | HttpErrorResponse): void {
    const notificationService: NotificationService =
      this.injector.get(NotificationService);
    console.error(error);

    if (
      error instanceof EvalError ||
      error instanceof RangeError ||
      error instanceof ReferenceError ||
      error instanceof SyntaxError ||
      error instanceof TypeError ||
      error instanceof URIError
    ) {
      const notification: Notification = {
        text: _('errors.default'),
        config: { timeout: null }
      };
      notificationService.showErrorNotification(notification);
    }
  }
}
